import { useState, type FormEvent } from 'react';
import type { AuthSession } from '../auth.js';
import { Button, Icon, Note, TextField } from '../ui/index.js';

export function SignInPage({ auth }: { auth: AuthSession }) {
  const [email, setEmail] = useState(''); const [sent, setSent] = useState(false); const [error, setError] = useState<string | null>(null); const [busy, setBusy] = useState<'google' | 'email' | null>(null);
  const google = async () => { setBusy('google'); setError(null); try { await auth.signInWithGoogle(); } catch (e) { setError(describe(e)); } finally { setBusy(null); } };
  const link = async (e: FormEvent) => {
    e.preventDefault(); setError(null);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) { setError('Enter a full email address.'); return; }
    setBusy('email');
    try { await auth.sendSignInLink(email.trim()); setSent(true); } catch (e) { setError(describe(e)); } finally { setBusy(null); }
  };
  return (
    <main className="rv-signin">
      <div className="rv-signin__card">
        <div className="rv-brand"><Icon name="sparkles" size={20} /><span>Rainvic</span></div>
        <h1 className="rv-display">Sign in</h1>
        <Button variant="primary" size="lg" onClick={google} busy={busy === 'google'}>Continue with Google</Button>
        <div className="rv-or" aria-hidden="true">or</div>
        {sent ? <Note>Check {email.trim()} for the sign-in link.</Note> : (
          <form onSubmit={link} className="rv-stack" noValidate>
            <TextField label="Email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.currentTarget.value)} placeholder="you@studio.com" />
            <Button type="submit" size="lg" icon="mail" busy={busy === 'email'}>Email me a link</Button>
          </form>)}
        {error ? <Note tone="danger">{error}</Note> : null}
      </div>
    </main>
  );
}
export function describe(e: unknown): string {
  const m = e instanceof Error ? e.message : String(e);
  if (m.includes('popup-closed')) return 'The sign-in window was closed before finishing.';
  if (m.includes('invalid-email')) return 'That email address is not valid.';
  if (m.includes('network')) return 'The network is unavailable. Try again.';
  return m;
}
